import axios from '../plugins/axios'

// 获取分页的数据
function getPageData2(url, data) {
    return axios.get(url, {
        params: {
            ...data,
            size: 20,
        }
    }).then(res => {
        // console.log(res);
        return {
            data: res.data,
            hasNextPage: res.data.result.pageInfo.hasNextPage
        }
    })
}

const requestService = {

    sjm: {
        getRecommendList(materialId, type, page) {
            return getPageData2('/api/outside/getRecommendList', {
                materialId,
                type,
                page
            })
        },
        getMaterial(materialId, type) {
            return axios.get('/api/outside/getMaterial', {params: {materialId, type}})
        },
        acceptInvite(params) {
            return axios.post('/api/outside/acceptInvite', params);
        }
    },

    wechat: {
        acceptInvite(params) {
            return axios.post('/user/acceptInvite', params);
        }
    }
};

export default requestService
